import { clsx } from 'clsx'
import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { IconInfo } from '@redteclab/icons'

import { erxBonusLandingPageTextAccent } from '../../../../components/ErxBonusLandingPageTranslationValues'

import {
  ErxBonusLandingPageHowBonusIsCalculatedTableDataBody,
  ErxBonusLandingPageHowBonusIsCalculatedTableDataHead,
} from './ErxBonusLandingPageHowBonusIsCalculatedData'

import styles from './ErxBonusLandingPageHowBonusIsCalculated.module.css'

export const HOW_BONUS_CALCULATED_SECTION_ID = 'how-bonus-is-calculated'

export const ErxBonusLandingPageHowBonusIsCalculated: FC = () => {
  return (
    <div
      className="flex scroll-mt-4 flex-col gap-6 text-dark-primary-max tablet:flex-row"
      id={HOW_BONUS_CALCULATED_SECTION_ID}
    >
      <div
        className={clsx(
          styles['section-calculation'],
          '-mt-3 flex flex-col gap-4 rounded-2xl bg-light-primary-low p-6',
        )}
      >
        <p className="text-m font-medium">
          <FormattedMessage id="deErx.oldBonus.HowPrescriptionIsCalculated.title" />
        </p>

        <p className="text-s">
          <FormattedMessage id="deErx.oldBonus.HowPrescriptionIsCalculated.description" />
        </p>

        <div className="flex flex-row gap-1">
          <IconInfo className="size-6 shrink-0 text-dark-accent" />
          <span className="font-medium">
            <FormattedMessage id="deErx.oldBonus.HowPrescriptionIsCalculated.info" />
          </span>
        </div>
      </div>

      <div className="flex flex-col gap-1 rounded-2xl bg-light-primary-low tablet:-mt-3">
        <div className="p-6">
          <p className="text-m font-medium">
            <FormattedMessage id="deErx.oldBonus.HowPrescriptionIsCalculated.table.title" />
          </p>
        </div>

        <div className="tablet:px-6">
          <table
            className={clsx(styles['rounded-table'], 'table-auto text-xs')}
          >
            <thead className="bg-light-brand-medium">
              <tr className="text-center font-medium">
                {ErxBonusLandingPageHowBonusIsCalculatedTableDataHead.map(
                  (head) => {
                    return (
                      <td className="px-3 py-2" key={head.key}>
                        {head.heading}
                      </td>
                    )
                  },
                )}
              </tr>
            </thead>
            <tbody className="bg-light-brand-low">
              {ErxBonusLandingPageHowBonusIsCalculatedTableDataBody.map(
                (data, index) => {
                  const rowClass = clsx(
                    index <
                      ErxBonusLandingPageHowBonusIsCalculatedTableDataBody.length -
                        1 && 'border-b border-dark-primary-min',
                  )

                  return (
                    <tr className={rowClass} key={data.key}>
                      <td className="px-4 py-3">{data.medication}</td>
                      <td className="px-4 py-3">
                        <div className="flex justify-center">
                          <div className="w-fit rounded-xl bg-light-tertiary p-2">
                            {data.perscriptionBonus}
                          </div>
                        </div>
                      </td>
                      <td className="px-4 py-3">
                        <div className="flex justify-center">
                          <div className="w-fit rounded-xl bg-light-tertiary p-2">
                            {data.totalBonus}
                          </div>
                        </div>
                      </td>
                    </tr>
                  )
                },
              )}
            </tbody>
          </table>
        </div>

        <div className="px-6 py-3">
          <p className="text-s">
            <FormattedMessage
              id="deErx.oldBonus.HowPrescriptionIsCalculated.savingInfo"
              values={{
                accentuate: erxBonusLandingPageTextAccent,
              }}
            />
          </p>
        </div>
      </div>
    </div>
  )
}
